import JournalBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/JournalBlockForm";
import HeroBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/HeroBlockForm";
import ProductListBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/ProductListBlockForm";
import TrustBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/TrustBlockForm";
import FaqsBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/FaqsBlockForm";
import ComplianceBarBlock from "../../models/blocks/ComplianceBarBlock";
import PageHeaderBlock from "../../models/blocks/PageHeaderBlock";
import LinkBlock from "../../models/blocks/LinkBlock";
import PageFooterBlock from "../../models/blocks/PageFooterBlock";
import FooterLinksBlock from "../../models/blocks/FooterLinksBlock";
import FooterBenefitsBlock from "../../models/blocks/FooterBenefitsBlock";
import AnnouncementBarBlock from "../../models/blocks/AnnouncementBarBlock";
export default {
  [AnnouncementBarBlock.NAME]: {
    default_announcement: {
      [ComplianceBarBlock.getTextAttributeName()]: 'Spedizione gratuita oggi!'
    }
  },
  [ComplianceBarBlock.NAME]: {
    default_compliance: {
      [ComplianceBarBlock.getTextAttributeName()]: 'Copyright © {from}-{to} {domain_name}. Tutti i diritti riservati.'
    }
  },
  [PageHeaderBlock.NAME]: {
    default_header: {
      [PageHeaderBlock.getLinksAttributeName()]: [{
        [LinkBlock.getNameAttributeName()]: 'Home'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Prodotti'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Faq'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Chi siamo'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Contactto'
      }]
    }
  },
  [PageFooterBlock.NAME]: {
    default_footer: {
      [PageFooterBlock.getSectionsAttributeName()]: [{}, {
        [FooterLinksBlock.getTitleAttributeName()]: 'Informazioni',
        [FooterLinksBlock.getLinksAttributeName()]: [{
          [LinkBlock.getNameAttributeName()]: 'Spedizione e Resi'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Faq'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Chi siamo'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Contactto'
        }]
      }, {
        [FooterLinksBlock.getTitleAttributeName()]: 'Pagine legali',
        [FooterLinksBlock.getLinksAttributeName()]: [{
          [LinkBlock.getNameAttributeName()]: 'Termini e Condizioni'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Informativa Sulla Priva'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Rimborso'
        }]
      }, {
        [FooterBenefitsBlock.getParagraphAttributeName()]: '<p><strong>Pagamento sicuro</strong></p><p><strong>Spedizione gratuita e veloce </strong><span><strong>( da 5 a 8 giorni )</strong></span></p>'
      }]
    }
  },
  [HeroBlockForm.NAME]: {
    home: {
      text: '<p style="text-align: justify; padding: 0.1px" dir="ltr"><span style="font-size: 20pt; color: #FFFFFF">Incredibile esperienza di acquisto online!</span></p><p style="text-align: justify; padding: 0.1px" dir="ltr"></p><ul dir="auto" style="padding-inline-start: 24px"><li style="color: #FFFFFF"><p dir="auto" style="padding: 0.1px"><span style="font-size: 18pt; color: #FFFFFF">Prodotti di alta qualità</span></p></li><li style="color: #FFFFFF"><p dir="auto" style="padding: 0.1px"><span style="font-size: 18pt; color: #FFFFFF">Sconti incredibili</span></p></li><li style="color: #FFFFFF"><p dir="auto" style="padding: 0.1px"><span style="font-size: 18pt; color: #FFFFFF">Consegna veloce</span></p><p dir="auto" style="padding: 0.1px"></p></li></ul><p dir="auto" style="padding: 0.1px"><span style="font-size: 20pt; color: #FFFFFF"> Non esitare! Amerai i nostri prodotti</span></p>',
      button_text: 'Scopri i nostri prodotti'
    }
  },
  [ProductListBlockForm.NAME]: {
    discover_products: {
      title: 'Scopri i nostri prodotti'
    }
  },
  [JournalBlockForm.NAME]: {
    amazing_delivery_experience: {
      title: 'Esperienza di consegna soddisfacente',
      paragraph: '<p style="text-align: justify; padding: 0.1px" dir="ltr">Puoi effettuare l&apos;ordine nel nostro negozio in tutta tranquillità, abbiamo collaborato con i migliori corrieri in {country_name} per fornirti tempi di consegna rapidi da 5 a 8 giorni, e un metodo di pagamento sicuro online, con carta o contrassegno a seconda del prodotto.</p>'
    },
    best_customer_service: {
      title: 'Il miglior servizio clienti',
      paragraph: '<p style="text-align: justify; padding: 0.1px" dir="auto">Il nostro servizio clienti è sempre qui per rispondere alle tue domande e aiutarti con il tuo ordine, così come nel post vendita.Facciamo del nostro meglio per rispondere a tutti i nostri clienti in meno di 24 ore. In caso di domande, contattaci da <a target="_blank" rel="noopener noreferrer nofollow" href="https://maxcomshop.com/contact"><strong>questa pagina</strong></a></p>'
    },
    about_us: {
      title: 'CHI SIAMO',
      paragraph: '<p dir="auto" style="padding: 0.1px">:domain_title è un negozio online in :country_name specializzato in prodotti e accessori innovativi che renderanno la tua vita quotidiana più facile e molto più divertente.Facciamo del nostro meglio per fornire un supporto di qualità e tempi di spedizione più rapidi ai nostri clienti. Promettiamo di elaborare i tuoi ordini in meno di 24 ore e di rispondere a tutte le tue domande in tempo.Siamo felici di darti il benvenuto nel nostro negozio, siamo liberi di effettuare ordini in qualsiasi momento :) La tua soddisfazione è il nostra priorità.</p>'
    }
  },
  [TrustBlockForm.NAME]: {
    satisfaction_guarantee: {
      title: 'Garanzia di soddisfazione al 100%',
      paragraph: 'Offriamo la spedizione gratuita su tutti i prodotti e ti diamo 30 giorni di garanzia per testare il prodotto',
      badges_list: [{
        text: 'Spedizione gratuita'
      }, {
        text: 'Garanzia di reso'
      }, {
        text: 'Pagamento sicuro'
      }, {
        text: 'Assistenza clienti veloce'
      }]
    }
  },
  [FaqsBlockForm.NAME]: {
    home: {
      title: 'FAQ',
      other_questions_title: 'Hai altre domande?',
      other_questions_text: '<p style="color: #FFFFFF; text-align: center; padding: 0.1px" dir="ltr">Visita la pagina dei contatti e inviaci il tuo messaggio. Facciamo del nostro meglio per rispondere a tutti i nostri clienti in meno di 24H</p>',
      other_questions_button_text: 'Contattaci',
      faqs_list: [{
        title: 'COME POSSO SEGUIRE I MIEI ORDINI E PAGAMENTI?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Invieremo il numero di tracciamento via e-mail subito dopo la spedizione dell\'ordine.</span></p>'
      }, {
        title: 'E SE DEVO RESTITUIRE IL PRODOTTO?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Non preoccuparti! Contattaci il prima possibile nei primi 7 giorni dalla ricezione del tuo ordine e ti aiuteremo a elaborare il reso e il rimborso o il cambio.</span></p>'
      }, {
        title: 'QUANTO TEMPO SERVE PER RICEVERE IL MIO ORDINE?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Il tuo ordine verrà consegnato entro 5-8 giorni dalla conferma dell\'ordine, a seconda del volume degli ordini ricevuti. In caso di ritardo nella ricezione del tuo ordine, ti preghiamo di contattarci e ti aiuteremo a confermare lo stato del tuo ordine.</span></p>'
      }, {
        title: 'QUALI POSSIBILITÀ DI PAGAMENTO ?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Puoi pagare con carta online o in contrassegno a seconda del prodotto. La transazione è sicura al 100% e non salviamo i dati della tua carta.</span></p>'
      }, {
        title: 'COSA SUCCEDE SE LA MIA CONSEGNA È DANNEGGIATA O SMARRITA?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Prendiamo questi problemi molto sul serio e li affronteremo caso per caso. Per ulteriori informazioni sulla nostra politica di cambio e rimborso, per favore </span><a target="_blank" rel="noopener noreferrer nofollow" href="/shipping-return-policy"><span><strong>clicca qui</strong></span></a><span>.</span></p>'
      }]
    }
  }
};